import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useThemeStore = defineStore('theme', () => {
  const isDarkMode = ref(false);

  function toggleDarkMode() {
    isDarkMode.value = !isDarkMode.value;
    updateDOM();
    saveToStorage();
  }

  function setDarkMode(value) {
    isDarkMode.value = value;
    updateDOM();
    saveToStorage();
  }

  function updateDOM() {
    if (isDarkMode.value) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }

  function saveToStorage() {
    localStorage.setItem('darkMode', isDarkMode.value.toString());
  }

  function initializeTheme() {
    // Check localStorage first
    const stored = localStorage.getItem('darkMode');
    if (stored !== null) {
      isDarkMode.value = stored === 'true';
    } else {
      // Check system preference
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      isDarkMode.value = prefersDark;
    }
    updateDOM();
  }

  return {
    isDarkMode,
    toggleDarkMode,
    setDarkMode,
    initializeTheme
  };
});
